import React, { createContext, useContext, useEffect, useState, ReactNode } from "react";
import { PinData } from "../types";
import { PinService } from "../services/pinService";

interface PinContextType {
  pins: PinData[];
  addPin: (xRatio: number, yRatio: number, type: string, mapId: string) => Promise<void>;
  removePin: (id: string) => Promise<void>;
}

const PinContext = createContext<PinContextType | undefined>(undefined);

/**
 * Pin コンテキストプロバイダー
 */
export const PinProvider: React.FC<{
  children: ReactNode;
  mapId: string;
}> = ({ children, mapId }) => {
  const [pins, setPins] = useState<PinData[]>([]);
  const [pinService] = useState(() => new PinService());

  useEffect(() => {
    // ピンの購読を開始
    pinService.subscribe(mapId);
    const unsubscribe = pinService.onChange(setPins);

    return () => {
      unsubscribe();
      pinService.dispose();
    };
  }, [mapId, pinService]);

  const addPin = async (
    xRatio: number,
    yRatio: number,
    type: string,
    mapId: string
  ): Promise<void> => {
    await pinService.addPin(xRatio, yRatio, type as any, mapId);
  };

  const removePin = async (id: string): Promise<void> => {
    await pinService.removePin(id);
  };

  return (
    <PinContext.Provider value={{ pins, addPin, removePin }}>
      {children}
    </PinContext.Provider>
  );
};

/**
 * Pin コンテキストを使用するフック
 */
export const usePins = (): PinContextType => {
  const context = useContext(PinContext);
  if (!context) {
    throw new Error("usePins must be used within PinProvider");
  }
  return context;
};
